import './App.css';

import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import '@fontsource/montserrat/800.css';
import '@fontsource/cormorant-garamond/600.css';
import {Grid} from "@mui/system";
import Pagina from "./Pagina/Pagina";
import {createContext, useEffect, useState} from "react";
import {guardarObjLocal} from "./Servicios/Local/guardarObjLocal";
import {guardarStringLocal} from "./Servicios/Local/guardarStringLocal";
import {obtenerColWheres} from "./Servicios/BD/obtenerColWheres";
import {where} from "firebase/firestore";
import {obtenerObjLocal} from "./Servicios/Local/obtenerObjLocal";
import {obtenerDoc} from "./Servicios/BD/obtenerDoc";
import {obtenerStringLocal} from "./Servicios/Local/obtenerStringLocal";
import {useObtenerDataActualizada} from "./Modulo_Optimizacion_Data/Hooks/useObtenerDataActualizada";
import {obtenerFechaAct} from "./Servicios/BD/Actualizadores/obtenerFechaAct";
import {useFuncionesCarritoLateral} from "./Modulo_Carrito_Lateral/Hooks/useFuncionesCarritoLateral";

export const contexApp = createContext()

function App() {
    const {data: dataSubCat, actualizarDataLocal: actSubCat} = useObtenerDataActualizada({clave: 'subcategorias'})
    const {data: colecciones, actualizarDataLocal: actColecciones} = useObtenerDataActualizada({clave: 'colecciones'})
    const {data: anuncios, actualizarDataLocal: actAnuncios} = useObtenerDataActualizada({clave: 'anuncios'})
    const {data: looks, actualizarDataLocal: actLooks} = useObtenerDataActualizada({clave: 'looks'})
    const {
        data: configuraciones,
        actualizarDataLocal: actConfiguraciones
    } = useObtenerDataActualizada({clave: 'configuraciones'})
    const [actColeccion, setActColeccion] = useState({})
    const {setProductos} = useFuncionesCarritoLateral()


    const valoresProvider = {
        actColeccion,
        configuraciones,
        subCategorias: dataSubCat,
        colecciones,
        anuncios,
        looks
    }

    const {Provider} = contexApp;

    const obtenerDatos = async () => {

        let doxFechaAct = await obtenerDoc('actualizaciones', 'fecha')
        let fecha = undefined

        if (doxFechaAct.res && doxFechaAct.data) {
            fecha = doxFechaAct.data.fecha
        }

        let fechaLocal = obtenerStringLocal({key: 'fecha'})

        if (!fechaLocal || !fecha || (fechaLocal < fecha)) {

            await actualizarColeccion(fecha)

        } else {
            let colActual = obtenerObjLocal({key: 'colActual'})
            setActColeccion(colActual)

        }


    }


    const actualizarColeccion = async (fecha) => {

        let w = [where('actual', '==', 'Si')]
        let doxCol = await obtenerColWheres({col: 'colecciones', wheres: w})

        if (doxCol.res && doxCol.data[0]) {
            guardarObjLocal({key: 'colActual', obj: doxCol.data[0]})
            guardarStringLocal({key: 'fecha', dato: fecha})
            setActColeccion(doxCol.data[0])
        }
    }


    useEffect(() => {

        obtenerFechaAct('subCategorias').then((dox) => {
            let w = []
            actSubCat({fecha: dox, wheres: w}).then()
        })

        obtenerFechaAct('colecciones').then((dox) => {
            let w = []
            actColecciones({fecha: dox, wheres: w}).then()
        })

        obtenerFechaAct('anuncios').then((dox) => {
            let w = []
            actAnuncios({fecha: dox, wheres: w}).then()
        })

        obtenerFechaAct('looks').then((dox) => {
            let w = [where('estado', '==', 'Publicado'), where('home', '==', true)]
            actLooks({fecha: dox, wheres: w}).then()
        })

        obtenerFechaAct('configuraciones').then((dox) => {
            let w = []
            actConfiguraciones({fecha: dox, wheres: w}).then()
        })

        obtenerDatos()


        let carritoLocal = obtenerObjLocal({key: 'carrito'})
        if (carritoLocal) {
            setProductos(carritoLocal)
        }


    }, [])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{maxWidth: '100%', overflowX: 'hidden'}}
        >

            <Provider value={valoresProvider}>

                <Pagina/>


            </Provider>


        </Grid>
    );
}

export default App;
